<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="item">城市公司名称：{{form.beforeStr.cityCompany.name}}</div>
          <div class="item">负责人：{{form.beforeStr.cityCompany.charge_name}}</div>
          <div class="item">手机号：{{form.beforeStr.cityCompany.pho}}</div>
          <div class="item">所在区域：{{form.beforeStr.cityCompany.addr_province}}{{form.beforeStr.cityCompany.addr_city}}{{form.beforeStr.cityCompany.addr_area}}</div>
          <div class="item">详细地址：{{form.beforeStr.cityCompany.addr_detail}}</div>
          <div class="item">入驻时间：{{form.beforeStr.cityCompany.check_in_time}}</div>
          <div class="item">状态：{{form.beforeStr.cityCompany.state?'启用':'禁用'}}</div>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="item">城市公司名称：{{form.afterStr.cityCompany.name}}</div>
          <div class="item">负责人：{{form.afterStr.cityCompany.charge_name}}</div>
          <div class="item">手机号：{{form.afterStr.cityCompany.pho}}</div>
          <div class="item">所在区域：{{form.afterStr.cityCompany.addr_province}}{{form.afterStr.cityCompany.addr_city}}{{form.afterStr.cityCompany.addr_area}}</div>
          <div class="item">详细地址：{{form.afterStr.cityCompany.addr_detail}}</div>
          <div class="item">入驻时间：{{form.afterStr.cityCompany.check_in_time}}</div>
          <div class="item">状态：{{form.afterStr.cityCompany.state?'启用':'禁用'}}</div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
